import { Component, OnInit, Input } from '@angular/core';
import { ItemCounterComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-item-counter',
  templateUrl: './ek-item-counter.component.html',
  styleUrls: ['./ek-item-counter.component.scss']
})
export class EkItemCounterComponent extends ItemCounterComponent  {
  @Input() max: number = 999;
  disablePlus: boolean = false;
  increment() {
    // it's too early to use the `stepUp` and `stepDown` API...
    // let's wait for FF: https://caniuse.com/#search=stepUp
    console.log("xxx",this.control.value);
    if(this.control.value >= 999){
      this.disablePlus = true;
    }

    this.control.setValue(this.control.value < 999 ? this.control.value + this.step: 999);
    this.control.markAsDirty();
  }

}
